<template>
  <div class="step-discount-verification">
    <AccessPassVerification v-if="discountVerificationType === 'access'" />
    <NevadaEBT v-else-if="discountVerificationType === 'nevada_rf'" />
    <!-- <NevadaPassVerification v-else-if="discountVerificationType === 'nevada_rf'" /> -->
    <MetroPassVerification v-else-if="discountVerificationType === 'metro_rf'" />
    <PasscodeVerification v-else />
  </div>
</template>
<script>
import store from '../store';

import AccessPassVerification from '../components/verification/indego_validation_types/AccessPassVerification.vue';
// import NevadaPassVerification from '../components/verification/rtc_validation_types/NevadaPassVerification.vue';
import NevadaEBT from '../components/verification/rtc_validation_types/NevadaEBT.vue';
import MetroPassVerification from '../components/verification/MetroPassVerification.vue';
import PasscodeVerification from '../components/verification/PasscodeVerification.vue';

export default {
  components: {
    AccessPassVerification,
    NevadaEBT,
    // NevadaPassVerification,
    MetroPassVerification,
    PasscodeVerification,
  },
  computed: {
    discountVerificationType() {
      return this.$store.getters.passType.discountVerificationType;
    },
  },
  beforeRouteEnter(to, from, next) {
    if (store.state.registration.discountVerificationNonce) {
      next({
        name: from.name === 'pass' ? store.getters.nextStep(to.name) : 'pass',
      });
      return;
    }
    next();
  },
};
</script>
